import * as React from 'react';

import styled from 'styled-components';

interface CoverArtIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const CoverArtIcon: React.FC<CoverArtIconProps> = (props) => {
  return (
    <svg x="0" y="0" width={20} height={15} viewBox="0 0 20 15" {...props}>
      <path
        className="icon"
        d="M19,15H1c-.79,0-1.26-.89-.84-1.57L3.72,7.7c.33-.53,1.03-.63,1.49-.22l2.29,2.04c.48,.42,1.21,.29,1.52-.27l3.61-6.6c.39-.71,1.39-.69,1.75,.03l5.5,10.83c.34,.68-.14,1.49-.88,1.49Z"
      />
      <ellipse className="icon" cx="5.04" cy="2" rx="1.95" ry="2" />
    </svg>
  );
};

export default styled(CoverArtIcon)`
  .icon {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
